import React from "react";

import { useNavigate } from "react-router";
import { routes } from "routes";

import SecondaryButton from "components/common/SecondaryButton";
import { useTranslations } from "components/useTranslations";

const UsersInviteButton: React.FC = () => {
  const navigateTo = useNavigate();
  const t = useTranslations();
  return (
    <SecondaryButton
      name="inviteUser"
      onClick={() => navigateTo(routes.userInvite)}
    >
      {t`__USERS_INITIAL_VIEW_INVITE_BUTTON`}
    </SecondaryButton>
  );
};

export default UsersInviteButton;
